<div class="te-ai-suggestion-panel p-3">
    <div class="flex align-items-center justify-content-between mb-3">
        <h5 class="m-0">AI Variablenvorschl&auml;ge</h5>
        <p-button icon="fa-regular fa-refresh" [text]="true" (click)="loadSuggestions()" [disabled]="loading"></p-button>
    </div>

    @if (loading) {
        <div class="flex justify-content-center p-5">
            <p-progressSpinner styleClass="w-3rem h-3rem" animationDuration=".5s"></p-progressSpinner>
        </div>
    } @else if (suggestions.length === 0) {
        <div class="text-center text-500 p-3">
            <i class="fa-regular fa-brain text-4xl mb-2"></i>
            <p>Klicken Sie auf den Refresh-Button, um Vorschl&auml;ge zu laden.</p>
        </div>
    } @else {
        <div class="flex align-items-center mb-2">
            <p-checkbox [binary]="true" (onChange)="toggleAll($event.checked)" label="Alle ausw&auml;hlen"></p-checkbox>
            <span class="ml-auto text-sm text-500">{{suggestions.length}} Vorschl&auml;ge</span>
        </div>

        <div class="flex flex-column gap-2">
            @for (suggestion of suggestions; track suggestion.alias) {
                <div class="surface-50 border-round p-2 flex align-items-center gap-2">
                    <p-checkbox [(ngModel)]="suggestion.selected" [binary]="true"></p-checkbox>
                    <div class="flex-grow-1">
                        <div class="flex align-items-center gap-2">
                            <span class="font-medium">{{suggestion.name}}</span>
                            <p-tag [value]="suggestion.type" [severity]="suggestion.type === 'object' ? 'info' : 'secondary'" styleClass="text-xs"></p-tag>
                        </div>
                        <div class="text-sm text-500 mt-1">
                            <code>{{suggestion.alias}}</code>
                            @if (suggestion.objectTypeAlias) {
                                <span class="ml-2">&rarr; {{suggestion.objectTypeAlias}}</span>
                            }
                        </div>
                    </div>
                    <div class="flex align-items-center gap-1">
                        <i [class]="getSourceIcon(suggestion.source)" [pTooltip]="suggestion.source"></i>
                        <p-tag [value]="getConfidenceLabel(suggestion.confidence)" [severity]="getConfidenceSeverity(suggestion.confidence)" styleClass="text-xs"></p-tag>
                    </div>
                </div>
            }
        </div>

        <div class="mt-3">
            <p-button label="Ausgew&auml;hlte anwenden" icon="fa-regular fa-check" (click)="applySelected()" [disabled]="loading || !hasSelected()" styleClass="w-full"></p-button>
        </div>
    }
</div>
